import React from 'react';

import './WpInlineError.scss';

export interface Props {
  /** Content briefly explaining how to resolve the invalid form field input. */
  error: string;
  /** Unique identifier of the invalid form field that the message describes */
  id?: string;
}

const WpInlineError = ({ error, id }: Props) => {
  if (!error) {
    return null;
  }

  return (
    <div className="WpInlineError" id={id && `${id}Error`}>
      {error}
    </div>
  );
};

export default WpInlineError;
